import './front.scss';
import { FeatureCardsFront } from './FeatureCardsFront.js';

new FeatureCardsFront( document ).init();
